import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center gap-6" }



import Button from 'primevue/button';

import { useSelectViewItems } from '@/composables/useSelectViewItems';
import { useViewNavigation } from '@/composables/useViewNavigation';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationGroupNavigation',
  props: {
    "selectedItems": {
  type: Object,
  required: true,
},
    "selectedItemsModifiers": {},
  },
  emits: ["update:selectedItems"],
  setup(__props) {

const selectedItems = _useModel<{ [key: string]: number | null }>(__props, 'selectedItems');

const {
  nextGroupButton,
  prevGroupButton,
  nextElementButton,
  getNextNotSkipableGroup,
} = useViewNavigation();

const { handleNextGroup } = useSelectViewItems(selectedItems);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(prevGroupButton).route)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 0,
          to: _unref(prevGroupButton).route
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              class: "font-semibold",
              severity: "secondary",
              outlined: "",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(prevGroupButton).title), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (_unref(nextElementButton))
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 1,
          class: "font-semibold",
          size: "small",
          outlined: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleNextGroup)(_unref(nextElementButton).route)))
        }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "pi pi-plus" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_unref(nextElementButton).title), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(nextGroupButton).route)
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 2,
          class: "font-semibold",
          size: "small",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(handleNextGroup)(_unref(nextGroupButton).route)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(nextGroupButton).title), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(getNextNotSkipableGroup)())
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 3,
          to: {
        ..._unref(getNextNotSkipableGroup)(),
      }
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              class: "font-semibold",
              size: "small",
              outlined: ""
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Pomiń opcjonalne kroki ")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ]))
}
}

})